




























import { Vue, Component, Prop } from "vue-property-decorator";

import { IInvoice } from "@/models/invoices";
import { InvoiceStatusMap } from "@/data/enums/invoice";

@Component
export default class RelativeInvoiceStatus extends Vue {
  // Props

  @Prop({ required: true })
  public invoice!: IInvoice;

  @Prop({ default: "span" })
  public tag!: string;

  @Prop({ default: true })
  public showIcon!: boolean;

  @Prop({ default: false })
  public useCapitalised!: boolean;

  // Computed

  public get status() {
    return InvoiceStatusMap(this.invoice, this.$t("_.invoice"));
  }

  public get relativeDate() {
    return {
      datetime: this.status?.absolute?.date?.datetime,
      format: this.$t("_datetime.date.long")
    };
  }

  public get relativePath() {
    return this.status?.relative?.path;
  }

  public get shortCapitalisedLabel() {
    return this.status?.shortLabel.toString().toUpperCase();
  }
}
